import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  sectionTitle: {
    fontWeight: 'bold',
    fontSize: '1.8rem',
    textAlign: 'left',
    marginLeft: theme.spacing(1),
  },
  sectionDivider: {
    border: '1px solid lightgray',
    margin: '16px 0',
  },
  sectionDescription: {
    fontSize: '1.0rem',
    textAlign: 'left',
  },
  searchAndDescriptionRow: {
    marginBottom: theme.spacing(3),
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  textField: {
    backgroundColor: '#fff',
    width: '100%',
  },
  cardButtonBase: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: theme.spacing(2),
    border: '1px solid #e0e0e0',
    borderRadius: theme.shape.borderRadius,
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
    },
  },
  eventImagePlaceholder: {
    width: '100%',
    height: 200,
    backgroundColor: '#f0f0f0',
    marginBottom: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
  },
  orangeColor: {
    color: '#d85e00',
  },
  eventInfoRow: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  eventDateColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(0.5, 1),
    border: `1px solid ${theme.palette.warning.dark || '#d85e00'}`,
    borderRadius: theme.shape.borderRadius,
    minWidth: 60,
    marginRight: theme.spacing(2),
    backgroundColor: theme.palette.grey[50],
  },
  eventMonthText: {
    fontSize: '0.7rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    lineHeight: 1,
  },
  eventDayText: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    lineHeight: 1,
  },
  eventTitleLocationColumn: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  cardTitle: {
    fontWeight: 'bold',
    fontSize: '1rem',
    marginBottom: theme.spacing(0.5),
    textAlign: 'left',
  },
  cardSubtitle: {
    fontSize: '0.85rem',
    color: theme.palette.text.secondary,
    textAlign: 'left',
  },
  regulationIconContainer: {
    backgroundColor: '#D4F3FA',
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    marginRight: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));